import { createRouter, createWebHistory } from 'vue-router';
import HomeView from '@/views/HomeView.vue';
import AllGenres from '@/views/AllGenres.vue';
import GameDetails from '@/views/GameDetails.vue';
import Expired from '@/views/expiredView.vue';

const router = createRouter({
	history: createWebHistory(),
	routes: [
		{
			name: 'Home',
			path: '/',
			component: HomeView,
			props: true,
		},
		{
			path: '/login',
			name: 'Login',
			component: () => import('@/views/LoginView.vue'),
			props: true,
		},
		{
			name: 'Profile',
			path: '/profile',
			component: () => import('@/views/ProfileView.vue'),
			props: true,
		},
		{
			name: 'Genres',
			path: '/all-genres',
			component: AllGenres,
			props: true,
		},
		{
			name: 'GameDetails',
			path: '/game/:id',
			component: GameDetails,
			props: true,
		},
		{
			name: 'Subscription Expired',
			path: '/expired',
			component: Expired,
			props: true,
		},
		{
			name: 'access',
			path: '/access',
			beforeEnter: (to) => {
				const queryString = new URLSearchParams(to.query).toString();
				window.location.href = `/acl/access?${queryString}`;
			},
		},
	],
});

export default router;
